/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgChartScatterCategory = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M4 2v18h18v2H2V2zm5 10a3 3 0 1 1-.001 6.001A3 3 0 0 1 9 12zm8 0a3 3 0 1 1-.001 6.001A3 3 0 0 1 17 12zm-8 2a1 1 0 1 0 .001 2.001A1 1 0 0 0 9 14zm8 0a1 1 0 1 0 .001 2.001A1 1 0 0 0 17 14zM9 4a3 3 0 1 1-.001 6.001A3 3 0 0 1 9 4zm0 2a1 1 0 1 0 .001 2.001A1 1 0 0 0 9 6z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgChartScatterCategory as ChartScatterCategory };
